import React, { useState } from 'react';

import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { SiteDesignationTable, SiteSubcompanyTable, SiteEmployeeDetails, ConsultantAccountDetails, SiteDepartment, SiteEmployeeExcelData } from './WorkforceTable';

import usePermission from '../../config/permissions';
import { Attendance, GetAttendance } from '../Attendance';
import { Briefcase, Building2, ClipboardList, Clock, FileSpreadsheet, Users, Wallet } from 'lucide-react';

// const Wfm = () => {


//     const siteRole = sessionStorage.getItem("sitemanagement_role")
//     const COMPANYID = sessionStorage.getItem("sitemanagement_project_sub_company")

//     const [toggleState, setToggleState] = useState(1);
//     const getSelectedTitle = () => {
//         switch (toggleState) {

//             case 1:
//                 return 'Site Employees';
//             case 2:
//                 return 'Actual Attendance';
//             case 3:
//                 return 'BOQ Attendance';
//             case 4:
//                 return 'Office Rent';
//             case 5:
//                 return 'Site Designation'
//             case 6:
//                 return 'Site Sub Companies';
//             case 7:
//                 return 'Site Department';
//             case 8:
//                 return 'Consultant Account Details';
//             default:
//                 return 'Site Employees';
//         }
//     };


//     return (
//         <>
//             <Dashboardnavbar name={getSelectedTitle()} url="Employee Management" />
//             {siteRole === "SiteManagement" ?
//                 <div className='content-tabs'>
//                     <div className="toggle-button-area" style={{ padding: "34px 30px" }}>
//                         <button
//                             className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(1)}
//                         >
//                             Site Employees
//                         </button>
//                         <button
//                             className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(2)}
//                         >
//                             Actual Attendance
//                         </button>


//                         <button
//                             className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(3)}
//                         >
//                             BOQ Attendance
//                         </button>
//                     </div>
//                 </div>

//                 :
//                 <div className='content-tabs'>
//                     <div className="toggle-button-area">
//                         <button
//                             className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(1)}
//                         >
//                             Site Employees
//                         </button>
//                         <button
//                             className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(9)}
//                         >
//                             Employees Data
//                         </button>
//                         {
//                             siteRole === "BD" ? "" :
//                                 <>
//                                     <button
//                                         className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                                         onClick={() => setToggleState(2)}
//                                     >
//                                         Actual Attendance
//                                     </button>


//                                     <button
//                                         className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                                         onClick={() => setToggleState(3)}
//                                     >
//                                         BOQ Attendance
//                                     </button>
//                                 </>
//                         }

//                         {/* <button
//                             className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(4)}
//                         >
//                             Office Rent
//                         </button> */}

//                         <button
//                             className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                             onClick={() => setToggleState(5)}
//                         >
//                             Site Designation
//                         </button>

//                         {COMPANYID !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
//                             <button
//                                 className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                                 onClick={() => setToggleState(6)}
//                             >

//                                 Site Sub Companies
//                             </button>
//                         }
//                         {siteRole !== "ViewAccess" &&

//                             <button
//                                 className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                                 onClick={() => setToggleState(8)}
//                             >
//                                 Consultant Account Details
//                             </button>
//                         }
//                     </div>
//                 </div>
//             }
//             <div className="content-tabs">
//                 {toggleState === 1 ? <SiteEmployeeDetails /> : null}
//                 {toggleState === 2 ? <Attendance /> : null}
//                 {toggleState === 3 ? <GetAttendance /> : null}
//                 {toggleState === 5 ? <SiteDesignationTable /> : null}
//                 {/* {toggleState === 4 ? <OfficeRent /> : null} */}

//                 {toggleState === 6 ? <SiteSubcompanyTable /> : null}
//                 {toggleState === 7 ? <SiteDepartment /> : null}
//                 {toggleState === 8 ? <ConsultantAccountDetails /> : null}
//                 {toggleState === 9 ? <SiteEmployeeExcelData /> : null}


//             </div>
//         </>
//     );
// };


const Wfm = () => {
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const COMPANYID = sessionStorage.getItem("sitemanagement_project_sub_company");

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return 'Site Employees';
            case 2: return 'Actual Attendance';
            case 3: return 'BOQ Attendance';
            case 4: return 'Office Rent';
            case 5: return 'Site Designation';
            case 6: return 'Site Sub Companies';
            case 7: return 'Site Department';
            case 8: return 'Consultant Account Details';
            case 9: return 'Employees Data';
            default: return 'Site Employees';
        }
    };

    // Tab configuration based on role
    const getVisibleTabs = () => {
        if (siteRole === "SiteManagement") {
            return [
                { id: 1, label: 'Site Employees', icon: Users, show: true },
                { id: 2, label: 'Actual Attendance', icon: Clock, show: true },
                { id: 3, label: 'BOQ Attendance', icon: ClipboardList, show: true },
            ];
        }

        let tabs = [
            { id: 1, label: 'Site Employees', icon: Users, show: true },
            { id: 9, label: 'Employees Data', icon: FileSpreadsheet, show: true },
        ];

        if (siteRole !== "BD") {
            tabs.push(
                { id: 2, label: 'Actual Attendance', icon: Clock, show: true },
                { id: 3, label: 'BOQ Attendance', icon: ClipboardList, show: true }
            );
        }

        tabs.push({ id: 5, label: 'Site Designation', icon: Briefcase, show: true });

        if (COMPANYID !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c") {
            tabs.push({ id: 6, label: 'Site Sub Companies', icon: Building2, show: true });
        }

        if (siteRole !== "ViewAccess") {
            tabs.push({ id: 8, label: 'Consultant Account Details', icon: Wallet, show: true });
        }

        return tabs;
    };

    const visibleTabs = getVisibleTabs();

    const renderActiveComponent = () => {
        switch (toggleState) {
            case 1: return <SiteEmployeeDetails />;
            case 2: return <Attendance />;
            case 3: return <GetAttendance />;
            case 5: return <SiteDesignationTable />;
            case 6: return <SiteSubcompanyTable />;
            case 7: return <SiteDepartment />;
            case 8: return <ConsultantAccountDetails />;
            case 9: return <SiteEmployeeExcelData />;
            default: return null;
        }
    };

    return (
        <>

            <div className="project-details-modern">
                <div className="project-content-modern">
                    {/* Modern Tabs */}
                    <div className="modern-tabs-container">
                        <div className="tabs-scroll">
                            {visibleTabs.map((tab) => {
                                const Icon = tab.icon;
                                return (
                                    <button
                                        key={tab.id}
                                        className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                                        onClick={() => setToggleState(tab.id)}
                                    >
                                        <Icon size={16} />
                                        <span>{tab.label}</span>
                                        {toggleState === tab.id && <div className="active-indicator" />}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content-modern">
                        {renderActiveComponent()}
                    </div>
                </div>
            </div>
        </>
    );
};


export default Wfm;
